<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-edit text-primary"></i></a>

    <b-modal ref="modal" hide-footer title="Salary packaging provider">
        <div class="d-block">
          <form>

            <div class="form-group">
              <label for="provider">Provider</label>
              <input type="text" 
              class="form-control" 
              id="provider" 
              placeholder="Provider"
              v-model="name">
              <div class="invalid-feedback" v-if="errors.name">{{ errors.name[0] }}</div>
            </div>
            <div class="form-group">
              <label for="fee">Fee</label>
              <input type="number" 
              class="form-control" 
              id="fee" 
              placeholder="Fee"
              v-model="fee">
              <div class="invalid-feedback" v-if="errors.fee">{{ errors.fee[0] }}</div>
            </div>
           <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="1"
                unchecked-value="0"
                >
                Status
            </b-form-checkbox>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="button" @click="fnUpdate()" class="btn btn-success btn-sm">Update</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../services/message.service';
    import * as salaryPackagingProviderService from '../../services/salaryPackagingProvider.service';
    export default {
        name:"ModalSalaryPackagingProviderEdit",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                id:'',
                name:'',
                fee:0,
                status:'',
            }
        },
        computed:{
            ...mapGetters(['gettSalaryPackagingProviderAll']),
        },
        methods:{
            ...mapActions(['fetchSalaryPackagingProviderAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.modal.hide();
            },
            showModal(){
                this.$refs.modal.show();
            },

            fnGetValue(props){
                this.id = props.rowData.id;
                this.status = props.rowData.status;
                this.name = props.rowData.name;
                this.fee = props.rowData.fee;
            },

            fnUpdate:async function(){
                const obj = {
                    "name":this.name,
                    "fee":this.fee,
                    "status":this.status
                }

                try{
                    await salaryPackagingProviderService.update(this.id, obj);
                    this.fetchSalaryPackagingProviderAll();
                    messageService.fnSweetAlertSuccessToast('Salary packaging provider', 'Updated successfully ');
                    this.hideModal();
                    this.id = ''; 
                    this.name = '';
                    this.fee = 0;
                    this.status ='';

                }catch(error){
                    messageService.fnSweetAlertErrorToast('Salary packaging provider - update', error.response.data.message);
                }
            }
        }
    }
</script>